<template>
  <div class="p-page-subtitle">
    <h2 class="f-title-24-bold t-fg-primary">{{ title }}</h2>
    <div class="p-page-subtitle__divider" />
  </div>
</template>

<script setup lang="ts">
defineProps({
  title: {
    type: String,
    required: true,
  },
})
</script>
